export default {"src":"/_next/static/media/npci.52c35286.svg","height":79,"width":222,"blurWidth":0,"blurHeight":0};